<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">个性化组件</div>

    <div class="search-wrapper">
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="类型">
          <el-select v-model="queryForm.businessType" placeholder="请选择类型">
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="item in businessList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" placeholder="请选择状态">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="未发布" :value="2"></el-option>
            <el-option label="已发布" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="margin-left-10" type="primary" @click="queryList"
        >搜索</el-button
      >
      <el-button @click="clickReset">重置</el-button>
    </div>

    <div class="action-wrapper">
      <el-button type="primary" @click="goEdit(null)">新增</el-button>
    </div>

    <div class="content-wrapper">
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column align="center" label="序号" width="80" prop="id">
        </el-table-column>
        <el-table-column align="center" label="类型" width="100">
          <template scope="{row}">
            {{ getTypeName(row.businessType) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="名称"
          width="160"
        ></el-table-column>
        <el-table-column align="center" label="图像" min-width="300">
          <template scope="{row}">
            <div class="img-box">
              <div class="img-list" v-if="row.businessType === 1">
                <div v-for="(item, index) in row.homeIcon" :key="index">
                  <el-popover
                    placement="right"
                    title="大图浏览"
                    trigger="hover"
                  >
                    <img
                      width="300"
                      max-height="300"
                      :src="item.backToTop"
                      alt=""
                    />
                    <img
                      slot="reference"
                      v-if="item.backToTop"
                      :src="item.backToTop"
                      alt=""
                    />
                  </el-popover>
                  <el-popover
                    placement="right"
                    title="大图浏览"
                    trigger="hover"
                  >
                    <img
                      width="300"
                      max-height="300"
                      :src="item.iconSelected"
                      alt=""
                    />
                    <img
                      slot="reference"
                      v-if="item.iconSelected"
                      :src="item.iconSelected"
                      alt=""
                    />
                  </el-popover>
                  <el-popover
                    placement="right"
                    title="大图浏览"
                    trigger="hover"
                  >
                    <img
                      width="300"
                      max-height="300"
                      :src="item.iconNormal"
                      alt=""
                    />
                    <img
                      slot="reference"
                      v-if="item.iconNormal"
                      :src="item.iconNormal"
                      alt=""
                    />
                  </el-popover>
                </div>
                <el-popover
                  v-if="row.homeIcon[0].backgroundImage"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeIcon[0].backgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].backgroundImage"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].homeBackgroundImage"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeIcon[0].homeBackgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].homeBackgroundImage"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].myBackgroundImage"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeIcon[0].myBackgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].myBackgroundImage"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].squareBackgroundUrl"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeIcon[0].squareBackgroundUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].squareBackgroundUrl"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].sportBackgroundUrl"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeIcon[0].sportBackgroundUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].sportBackgroundUrl"
                  />
                </el-popover>
                <el-popover
                  v-if="row.superscript"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.superscript"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.superscript"
                    :src="row.superscript"
                    alt=""
                  />
                </el-popover>
              </div>
              <div class="img-list" v-else-if="row.businessType === 3">
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.dynamicSticked.topUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.dynamicSticked.topUrl"
                    :src="row.dynamicSticked.topUrl"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.dynamicSticked.listUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.dynamicSticked.listUrl"
                    :src="row.dynamicSticked.listUrl"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.dynamicSticked.bottomUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.dynamicSticked.bottomUrl"
                    :src="row.dynamicSticked.bottomUrl"
                    alt=""
                  />
                </el-popover>
                <el-popover
                  v-if="row.superscript"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.superscript"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.superscript"
                    :src="row.superscript"
                    alt=""
                  />
                </el-popover>
              </div>
              <div class="img-list" v-else-if="row.businessType === 5">
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeRunSkinModel.publicityPicture"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.homeRunSkinModel.publicityPicture"
                    :src="row.homeRunSkinModel.publicityPicture"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeRunSkinModel.runGo"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.homeRunSkinModel.runGo"
                    :src="row.homeRunSkinModel.runGo"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeRunSkinModel.slideStart"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.homeRunSkinModel.slideStart"
                    :src="row.homeRunSkinModel.slideStart"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeRunSkinModel.endScoreReach"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.homeRunSkinModel.endScoreReach"
                    :src="row.homeRunSkinModel.endScoreReach"
                    alt=""
                  />
                </el-popover>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img
                    width="300"
                    max-height="300"
                    :src="row.homeRunSkinModel.endScoreNoReach"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.homeRunSkinModel.endScoreNoReach"
                    :src="row.homeRunSkinModel.endScoreNoReach"
                    alt=""
                  />
                </el-popover>
                <el-popover
                  v-if="row.superscript"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.superscript"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.superscript"
                    :src="row.superscript"
                    alt=""
                  />
                </el-popover>
              </div>
              <div class="img-list" v-else-if="row.businessType === 6">
                <div v-for="(item, index) in row.emojiList" :key="index">
                  <el-popover
                    placement="right"
                    title="大图浏览"
                    trigger="hover"
                  >
                    <img width="300" max-height="300" :src="item.url" alt="" />
                    <img
                      slot="reference"
                      v-if="item.url"
                      :src="item.url"
                      alt=""
                    />
                  </el-popover>
                </div>
                <el-popover
                  v-if="row.superscript"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.superscript"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.superscript"
                    :src="row.superscript"
                    alt=""
                  />
                </el-popover>
              </div>
              <div class="img-list" v-else>
                <el-popover placement="right" title="大图浏览" trigger="hover">
                  <img width="300" max-height="300" :src="row.content" alt="" />
                  <img
                    slot="reference"
                    v-if="row.content"
                    :src="row.content"
                    alt=""
                  />
                </el-popover>
                <el-popover
                  v-if="row.superscript"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    max-height="300"
                    :src="row.superscript"
                    alt=""
                  />
                  <img
                    slot="reference"
                    v-if="row.superscript"
                    :src="row.superscript"
                    alt=""
                  />
                </el-popover>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="同类型排序"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="皮肤效果"
          width="120"
        >
          <template scope="{row}">
            <el-popover
              v-if="row.effectImage"
              placement="right"
              title="大图浏览"
              trigger="hover"
            >
              <img width="300" max-height="300" :src="row.effectImage" alt="" />
              <img
                slot="reference"
                :src="row.effectImage"
                style="width: 50px; height: 50px"
                mode="scaleToFill"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="countUsed"
          label="当前装配人数"
          width="130"
        >
        </el-table-column>
        <el-table-column align="center" label="拥有学生" width="100">
          <template scope="{row}">{{ handleStudents(row) }}</template>
        </el-table-column>
        <el-table-column align="center" label="最新操作" width="180">
          <template scope="{row}">
            {{ getDate(row.updateAt) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="100">
          <template scope="{row}">
            <span v-if="row.status === 2">未发布</span>
            <span v-if="row.status === 3">已发布</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template scope="{row}">
            <!-- 【编辑】未发布的状态才有编辑按钮 -->
            <el-button type="text" v-if="row.status === 2" @click="goEdit(row)"
              >编辑</el-button
            >
            <el-button type="text" @click="goEdit(row, '2')">详情</el-button>
            <!-- 未发布时 -->
            <el-button
              v-if="row.status === 2"
              type="text"
              @click="handleRelease(row.id)"
              >发布</el-button
            >
            <!-- 未撤销显示 -->
            <el-button
              v-if="row.status === 3"
              type="text"
              @click="handleRevo(row.id)"
              >撤销</el-button
            >
            <el-button
              v-if="row.status === 2"
              type="text"
              @click="handleDelete(row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageForm.pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageForm.pageNumber"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      queryForm: {
        businessType: 0,
        status: 0,
      },
      pageForm: {
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      loading: false,
      businessList: [
        { label: "主题", value: 1 },
        { label: "头像挂件", value: 2 },
        { label: "动态卡片", value: 3 },
        { label: "海报贴纸", value: 4 },
        { label: "跑步皮肤", value: 5 },
        { label: "表情贴纸", value: 6 },
      ],
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getDate(time) {
      return new Date(time).format("yyyy/MM/dd hh:mm:ss");
    },

    getTypeName(type) {
      let business = this.businessList.find((item) => item.value === type);
      return business ? business.label : "";
    },

    getList() {
      this.loading = true;
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/personalizedComponents/list",
        params: {
          ...this.queryForm,
          ...this.pageForm,
        },
      })
        .then((res) => {
          if (res.data.error === 10000) {
            this.total = res.data.data.count;
            this.tableData = res.data.data.resModels.map((item) => {
              if (item.businessType === 6) {
                if (item.content && item.content !== "") {
                  item.emojiList = JSON.parse(item.content);
                } else {
                  item.emojiList = [];
                }
              }
              return item;
            });
          } else {
            this.$message.error(res.data.message || "请求错误");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    queryList() {
      this.pageForm.pageNumber = 1;
      this.getList();
    },
    // 点击重置
    clickReset() {
      this.queryForm.businessType = 0;
      this.queryForm.status = 0;
      this.pageForm.pageNumber = 1;
      this.pageForm.pageSize = 10;
      this.getList();
    },

    handleSizeChange(size) {
      this.pageForm.pageSize = size;
      this.getList();
    },

    handleCurrentChange(page) {
      this.pageForm.pageNumber = page;
      this.getList();
    },

    async handleRelease(id) {
      await this.$confirm("是否确定发布？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/personalizedComponents/change",
        params: {
          id,
          status: 3,
        },
      }).then((res) => {
        if (res.data.error === 10000) {
          this.$message.success("发布成功");
          this.getList();
        } else {
          this.$message.error(res.data.message || "发布失败");
        }
      });
    },

    async handleRevo(id) {
      await this.$confirm("撤销后将初始化已配置的用户，是否确认？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/personalizedComponents/change",
        params: {
          id,
          status: 2,
        },
      }).then((res) => {
        if (res.data.error === 10000) {
          this.$message.success("撤销成功");
          this.getList();
        } else {
          this.$message.error(res.data.message || "撤销失败");
        }
      });
    },

    async handleDelete(id) {
      await this.$confirm("是否确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      await this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/personalizedComponents/delete",
        params: {
          id,
        },
      }).then((res) => {
        if (res.data.error === 10000) {
          this.$message.success("删除成功");
          this.getList();
        } else {
          this.$message.error(res.data.message || "删除失败");
        }
      });
    },

    goEdit(row, edit = "1") {
      this.$router.push({
        path: "/yunying/userDiyEdit",
        query: {
          id: row ? row.id : "",
          edit,
        },
      });
    },
    // 处理拥有学生
    handleStudents(row) {
      if (row.useType === 0) {
        return "全部";
      } else if (row.useType === 1) {
        return row.countUsers;
      } else {
        const roles = row.roles || [];
        return roles.map((item) => item.name).join(", ");
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    if (from.path.includes("/yunying/userDiyEdit")) {
      to.meta.refresh = true;
    }
    next();
  },
  activated() {
    if (this.$route.meta.refresh) {
      this.$route.meta.refresh = false;
      this.getList();
    }
  },
};
</script>

<style scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
}

.img-list > div {
  display: flex;
  flex-wrap: wrap;
}

.img-box img {
  width: 50px;
  height: 50px;
  margin: 2px;
}
</style>



// WEBPACK FOOTER //
// PersonalizedPart.vue?bed7f132